import React, { useEffect, useState } from "react";
import {
  Box, Typography, TextField, Button, Grid,
  FormControl, RadioGroup, FormControlLabel, Radio,
} from "@mui/material";
import { useParams, useNavigate } from "react-router-dom";
import { useIntl } from "react-intl";

import { fetchProductType, updateProductType } from "../../api/companyApi";
import { useNotification } from "../../providers/NotificationProvider";

export default function ProductTypeEditPage() {
  const { businessDomainId, productTypeId } = useParams();
  const navigate = useNavigate();
  const intl = useIntl();
  const notify = useNotification();
  const t = (id) => intl.formatMessage({ id });

  const [form, setForm] = useState({
    productTypeId: "",
    companyId: "",
    businessDomainId: "",
    productTypeName: "",
    valueProposition: "",
    productClass: "",
  });
  const [fullData, setFullData] = useState(null);

  useEffect(() => {
    (async () => {
      try {
        const d = await fetchProductType(productTypeId);
        setFullData(d);
        setForm({
          productTypeId: d.productTypeId || "",
          companyId: d.companyId || "",
          businessDomainId: d.businessDomainId || "",
          productTypeName: d.productTypeName || "",
          valueProposition: d.valueProposition || "",
          productClass: d.productClass || "",
        });
      } catch (e) {
        notify.apiError(e);
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [productTypeId]);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.productClass) {
      notify.error(t("productType.error.noProductClass"));
      return;
    }
    try {
      const payload = { ...fullData, ...form };
      await updateProductType(payload);
      notify.success(t("message.update.success"));
      navigate(`/design/${businessDomainId}/product-types/${productTypeId}`);
    } catch (err) {
      notify.apiError(err);
    }
  };

  return (
    <Box>
      <Typography variant="h6" sx={{ mb: 2 }}>
        {t("productType.edit.title")}
      </Typography>

      <Box component="form" onSubmit={handleSubmit}>
        <Grid container spacing={2}>
          <Grid size={12}>
            <TextField fullWidth required multiline label={t("productType.name")} name="productTypeName" value={form.productTypeName} onChange={handleChange} />
          </Grid>
          <Grid size={12}>
            <TextField fullWidth required multiline rows={3} label={t("productType.valueProposition")} name="valueProposition" value={form.valueProposition} onChange={handleChange} />
          </Grid>
          <Grid size={12}>
            <FormControl component="fieldset">
              <RadioGroup row name="productClass" value={form.productClass} onChange={handleChange}>
                <FormControlLabel value="Goods" control={<Radio />} label={t("productType.class.goods")} />
                <FormControlLabel value="PersonalService" control={<Radio />} label={t("productType.class.personalService")} />
                <FormControlLabel value="ApplicationService" control={<Radio />} label={t("productType.class.applicationService")} />
              </RadioGroup>
            </FormControl>
          </Grid>
        </Grid>

        <Box sx={{ mt: 3, display: "flex", gap: 2 }}>
          <Button variant="contained" type="submit">{t("common.save")}</Button>
          <Button variant="outlined" onClick={() => navigate(`/design/${businessDomainId}/product-types/${productTypeId}`)}>{t("common.cancel")}</Button>
        </Box>
      </Box>
    </Box>
  );
}
